import { render, staticRenderFns } from "./AddUpdateShare.vue?vue&type=template&id=4f19d634&scoped=true"
import script from "./AddUpdateShare.vue?vue&type=script&lang=js"
export * from "./AddUpdateShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19d634",
  null
  
)

export default component.exports